module.exports = __webpack_public_path__ + "img/hero.53b79c33.jpg";